import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';
import { formatLocalDateTime } from '../../utils/dateTime';
import styles from './TimelineCard.module.scss';
const TimelineCard = ({ milestone, isFirst = false, isLast = false }) => {
    const { t } = useTranslation('translation', {
        keyPrefix: 'ASSESSMENT_HISTORY.MILESTONES'
    });
    const formattedDate = milestone.eventDateTime ? formatLocalDateTime(new Date(milestone.eventDateTime)) : formatLocalDateTime(new Date());
    const getDisplayText = () => {
        const { milestoneCode, physicianName, displayText } = milestone;
        if (milestoneCode === 'SLEEP_DATA_REVIEWED' && !physicianName) {
            return t('SLEEP_DATA_REVIEWED_NO_PHYSICIAN', { defaultValue: displayText });
        }
        return t(milestoneCode, {
            physician: physicianName !== null && physicianName !== void 0 ? physicianName : '',
            defaultValue: displayText
        });
    };
    const displayText = getDisplayText();
    return (_jsxs(Box, { className: styles.timeline_item, children: [_jsxs(Box, { className: styles.icon_column, children: [_jsx(Box, { className: `${styles.connector_line_top} ${isFirst ? styles.invisible : ''}` }), _jsx(Box, { className: styles.icon_circle, "aria-hidden": true, children: _jsx(CheckCircleOutlineIcon, { sx: { fontSize: 16 } }) }), _jsx(Box, { className: `${styles.connector_line_bottom} ${isLast ? styles.invisible : ''}` })] }), _jsxs(Box, { className: styles.timeline_card, children: [_jsx(Typography, { variant: "body1", className: styles.card_title, children: displayText }), formattedDate && (_jsx(Typography, { variant: "body2", className: styles.card_timestamp, children: formattedDate }))] })] }));
};
export default TimelineCard;
